import TrustedBy from './TrustedBy';

export default TrustedBy;
